import { cn } from "@garther/ui/libs";
import { Link, useRouter } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import LogoText from "@/assets/logo-text.svg?react";

import { AuthButton } from "./auth-button";

function NavLink({ to, children }: { to: string; children: React.ReactNode }) {
  const router = useRouter();
  const currentPath = router.state.location.pathname;
  const isActive = currentPath === to;
  return (
    <Link
      to={to}
      className={cn(
        "transition-colors text-responsive-base",
        isActive ? "text-text-primary font-medium" : "text-text-secondary hover:text-text-primary"
      )}
    >
      {children}
    </Link>
  );
}

export function Header() {
  const { t } = useTranslation();

  return (
    <header className="w-full bg-background-primary/80 backdrop-blur-md border-b border-border px-4 md:px-6 sticky top-0 z-50 pt-[calc(env(safe-area-inset-top)+0.5rem)] pb-2 md:pt-[calc(env(safe-area-inset-top)+0.75rem)] md:pb-3">
      <div className="max-w-7xl w-full mx-auto flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center space-x-3">
          <Link to="/" className="h-9 e-center overflow-hidden" aria-label="Garther Homepage">
            <LogoText className="w-full h-full object-contain" />
          </Link>

          {/* Navigation */}
          <nav className="pl-10 hidden md:flex items-center space-x-8">
            <NavLink to="/home" aria-label="Garther Homepage">
              {t("navigation.home")}
            </NavLink>
            {/* <NavLink to="/event">{t("navigation.events")}</NavLink> */}
            <NavLink to="/about-us" aria-label="Garther About Us">
              {t("navigation.aboutUs")}
            </NavLink>
          </nav>
        </div>

        {/* Authentication Section */}
        <AuthButton />
      </div>
    </header>
  );
}
